import { render, staticRenderFns } from "./TributeStoryUploader.vue?vue&type=template&id=eb12ac8c"
import script from "./TributeStoryUploader.vue?vue&type=script&lang=js"
export * from "./TributeStoryUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports